import axios from 'axios'
import { BUSCAR_OPCAO_DESCONTO_MEIA_PASSAGEM } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarOpcaoDescontoMeiaPassagem (codigo) {
  const url = `${URL}/usuarios/empresa/${codigo}/opcao-desconto-meia-passagem`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_OPCAO_DESCONTO_MEIA_PASSAGEM,
        payload: response

      })
  );
}
